import { render, staticRenderFns } from "./EnefficPresentation.vue?vue&type=template&id=040fa786&scoped=true"
import script from "./EnefficPresentation.vue?vue&type=script&lang=js"
export * from "./EnefficPresentation.vue?vue&type=script&lang=js"
import style0 from "./EnefficPresentation.vue?vue&type=style&index=0&id=040fa786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040fa786",
  null
  
)

export default component.exports